import { getToken, resetState } from "../utils/index";

export default {
  namespaced: true,
  state: {
    error: null,
    busy: false,
    loading: false,
    refresh: false,
    initialLoad: true,
    analytics: {},
  },
  mutations: {
    GET_AGENT_LIST_START: (state) => {
      state.loading = true;
      state.busy = true;
    },
    GET_AGENT_LIST_FAILED: (state, error) => {
      state.busy = false;
      state.loading = false;
      state.refresh = false;
      state.error = error;
    },
    GET_AGENT_LIST_SUCCESS: (state, agentList) => {
      state.busy = false;
      state.loading = false;
      state.refresh = false;
      state.initialLoad = false;
      state.list = agentList;
    },
    GET_AGENT_LIST_ANALYTICS_START: (state) => {
      state.loading = true;
    },
    GET_AGENT_LIST_ANALYTICS_FAILED: (state, error) => {
      state.loading = false;
      state.refresh = false;
      state.error = error;
    },
    GET_AGENT_LIST_ANALYTICS_SUCCESS: (state, analytics) => {
      state.loading = false;
      state.refresh = false;
      state.analytics = analytics;
      console.log(analytics);
    },
    REFRESH: (state) => {
      state.refresh = true;
    },
  },
  actions: {
    async getAgentList({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_AGENT_LIST_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/agents/lists?page=${payload.page}`,
          config
        );
        const data = await response.json();
        commit("GET_AGENT_LIST_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_AGENT_LIST_FAILED", err);
      }
    },
    async getAgentListAnalytics({ commit }) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_AGENT_LIST_ANALYTICS_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/agents/lists/analytics`,
          config
        );
        const data = await response.json();
        commit("GET_AGENT_LIST_ANALYTICS_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_AGENT_LIST_ANALYTICS_FAILED", err);
      }
    },
    async refresh({ commit }) {
      commit("REFRESH");
    },
  },
};
